// extracted by mini-css-extract-plugin
module.exports = {"root":"app_root__ToTUz"};